import { saveAs } from 'file-saver'

angular
  .module('deskfy.arts')
  .factory('ShareLinkService', shareLinkService)

/* @ngInject */
function shareLinkService ($state, ConnectorWebService, CONSTANTS, Utils, MessageService, SocketService, $q, ModalService, $rootScope) {
  const getDownloadMessagePublicFolderDialogController = () => $q.when(import('../dialogs/download-message-public-folder/download-message-public-folder-dialog.controller'))

  var service = {
    createShareLink,
    getShareLink,
    deleteShareLink,
    getShareLinkArt,
    downloadArt,
    update,
    sendInvites,
    createCollectionShareLink,
    getCollectionShareLink,
    getShareFolderlink,
    getThumbnailShareLink,
    getDownloadArtPublicFolder,
    downloadMultipleArts
  }
  return service

  function createShareLink (oPayload) {
    return ConnectorWebService.post(CONSTANTS.URL_SHARE_LINKS, oPayload)
      .then(function (oResponse) {
        oResponse.url = $state.href('publicDownload', { uuid: oResponse.uuid }, { absolute: true })
        return oResponse
      })
  }

  function getShareLink (iArtId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_LINKS_ID, [iArtId])
    return ConnectorWebService.get(sUrl)
      .then(function (oResponse) {
        if (oResponse) {
          oResponse.url = $state.href('publicDownload', { uuid: oResponse.uuid }, { absolute: true })
        }
        return oResponse
      })
  }

  function update (shareLinkId, payload) {
    var url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_LINKS_ID, [shareLinkId])
    return ConnectorWebService.put(url, payload)
  }

  function deleteShareLink (iId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_LINKS_ID, [iId])
    return ConnectorWebService.fnDelete(sUrl)
  }

  function getShareLinkArt (iUuid) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINK_ID, [iUuid])
    return ConnectorWebService.get(sUrl)
  }

  function getShareFolderlink (params) {
    const { iUuid, collectionsLimit, collectionsOffset, templatesLimit, templatesOffset, subcollectionId } = params

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_FOLDER_LINK_ID, [iUuid])

    if (collectionsLimit || collectionsOffset) {
      url = Utils.fnAddQueryToUrl(url, { collectionsLimit, collectionsOffset })
    }

    if (templatesLimit || templatesOffset) {
      url = Utils.fnAddQueryToUrl(url, { templatesLimit, templatesOffset })
    }

    if (subcollectionId) {
      url = Utils.fnAddQueryToUrl(url, { subcollectionId })
    }

    return ConnectorWebService.get(url)
  }

  function downloadArt (uuid, art) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINK_ID_DOWNLOAD, [uuid])
    url += '?fileFormat=' + art.extension

    if (art.extension === 'mp4') {
      SocketService.connectSocket('ExternalRenderVideo', { query: { uuid } })
    }

    return ConnectorWebService.createCustomXHR(encodeURI(url), 'GET', null, { responseType: 'arraybuffer' }, {}, { returnContext: true }).then((context) => {
      if (art.extension === 'mp4') return
      if (context.status === 403) {
        MessageService.error({
          title: 'oopsTitle',
          text: 'sharedLinkBusinessDataDownloadError',
          confirmButtonText: 'ok'
        })
        return
      }

      let fileName

      const contentType = context.getResponseHeader('Content-Type')

      const blob = new Blob([context.response], { type: contentType })

      const fileExtension = Utils.beautifyContentTypes(contentType)

      if (art.name) {
        fileName = art.name + '.' + fileExtension
      } else {
        fileName = 'Deskfy.' + fileExtension
      }

      saveAs(blob, fileName)
    })
  }

  function sendInvites (sharedLinkId, usersToNotify) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_LINKS_ID_INVITES, [sharedLinkId])
    return ConnectorWebService.post(sUrl, usersToNotify)
  }

  function createCollectionShareLink (oPayload) {
    return ConnectorWebService.post(CONSTANTS.URL_SHARE_LINKS_COLLECTION, oPayload)
      .then(function (oResponse) {
        oResponse.url = $state.href('publicFolder', { uuid: oResponse.uuid }, { absolute: true })
        return oResponse
      })
  }

  function getCollectionShareLink (collectionId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_LINKS_COLLECTION_ID, [collectionId])
    return ConnectorWebService.get(sUrl)
      .then(function (oResponse) {
        if (oResponse) {
          oResponse.url = $state.href('publicFolder', { uuid: oResponse.uuid }, { absolute: true })
        }
        return oResponse
      })
  }

  function getThumbnailShareLink (templateId, uuid, layerId, options) {
    const artUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID, [templateId, uuid])
    let url = Utils.fnAddQueryToUrl(artUrl, { artLayerId: layerId })

    if (options?.quality) {
      url = Utils.fnAddQueryToUrl(url, { quality: options.quality })
    }

    return url
  }

  function getDownloadArtPublicFolder (templateId, uuid, downloadModule) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_DOWNLOAD_ART_PUBLIC_FOLDER, [templateId, uuid])

    if (downloadModule) {
      url = Utils.fnAddQueryToUrl(url, { downloadModule })
    }

    return Utils.downloadFile(url)
  }

  function downloadMessagePublicFolderDialog (modalError = false, modalSuccess = false, modalLoading = true) {
    ModalService.close()
    getDownloadMessagePublicFolderDialogController().then(({ DownloadMessagePublicFolderDialogController }) => {
      ModalService.showModal({
        templateId: 'downloadMessagePublicFolder.html',
        templateUrl: '/arts/dialogs/download-message-public-folder/download-message-public-folder-dialog.html?$$REVISION$$',
        controller: DownloadMessagePublicFolderDialogController,
        destroyable: true,
        data: { modalError, modalSuccess, modalLoading }
      })
    })
  }

  function downloadMultipleArts (uuid, artIds, artCollectionIds) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_DOWNLOAD_MULTIPLE_ARTS, [uuid])

    if (artIds) {
      url = Utils.fnAddQueryToUrl(url, { artIds })
    }

    if (artCollectionIds) {
      url = Utils.fnAddQueryToUrl(url, { artCollectionIds })
    }

    downloadMessagePublicFolderDialog(false, false, true)

    return ConnectorWebService.createCustomXHR(
      url,
      'GET',
      null,
      { responseType: 'blob' },
      {
        load: () => {
          return function () {
            if (this.status !== 200) {
              downloadMessagePublicFolderDialog(true, false, false)
              return
            }

            const blob = this.response
            saveAs(blob)
            downloadMessagePublicFolderDialog(false, true, false)
            $rootScope.$broadcast('public-campaign.remove-selected-items')
          }
        },
        error: () => {
          return function () {
            downloadMessagePublicFolderDialog(true, false, false)
          }
        }
      }
    )
  }
}
